<template>
    <div>
        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">会员充值列表</span>
						<span style="margin-left:20px;">会员类别:</span>
						<RadioGroup v-model="userType"
						    style="margin-left:4px;"
						    @on-change="onUserTypeChage">
						    <Radio label="F"> <span>外部会员</span></Radio>
						    <Radio label="E"> <span>内部会员</span></Radio>
						</RadioGroup>
                        <span v-for="(item,index) in allTypeValue"
                            :key="index"
                            style="margin-left:10px;font-weight:bold;color:red;">
                            {{ formatPayType(item.bankRecordPaidType) }}合计:{{ item.totalValue }}元
                        </span>
                    </div>
                    <div class="right-bar" />
                </div>
                </Col>
            </Row>
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card ref="searchCard"
                    :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :extHeight="60"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { formatUserType } from '@/view/login/UserTypeDefine';
import { number2ThousandsFormat, numberToFixed } from '@/components/number-input/display-format';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getBankRecordList } from '@/api/modules/finance-management/bank-record';
import { formatPayType, getPayTypeOptions, PAY_TYPE_MANUAL } from './BankRecordStatus';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';

export default {
    name: 'BankRecordList',
    components: {
        SearchCard,
        StandPaginationTable
    },
    data() {
        return {
            userType:'F',
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '账号', key: 'userName', width: 80, align: 'center' },
                    { title: '姓名', key: 'userPersonName', width: 100, align: 'center' },
                    { title: '手机号码', key: 'userPhone', width: 120, align: 'center' },
                    {
                        title: '会员类型',
                        key: 'userType',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, formatUserType(params.row.bankRecordMemberType))
                            ]);
                        }
                    },
                    {
                        title: '充值方式',
                        key: 'bankRecordPaidType',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, formatPayType(params.row.bankRecordPaidType))
                            ]);
                        }
                    },
                    { title: '充值单号', key: 'bankRecordOrderNo', width: 220, align: 'center' },
                    {
                        title: '充值金额',
                        key: 'bankRecordOrderValue',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.bankRecordOrderValue, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '充值手续费',
                        key: 'bankRecordOrderValueFee',
                        width: 100,
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, number2ThousandsFormat(params.row.bankRecordOrderValueFee, 2, '￥'))
                            ]);
                        }
                    },
                    { title: '备注', key: 'bankRecordRemark', width: 220, align: 'center' },
                    { title: '充值时间', key: 'bankRecordPayTime', width: 130, align: 'center', render: (h, params) => dateTimeRender(h, params.row.bankRecordPayTime) }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: true,
                searchForm: [
                    { label: '会员账号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    // { label: '会员手机', type: 'Input', value: '', name: 'phone', sql: 'like' },
                    {
                        label: '充值方式',
                        type: 'Select',
                        value: [],
                        name: 'bankRecordPaidType',
                        sql: 'in',
                        options: getPayTypeOptions()
                    },
                    { label: '充值时间', type: 'Daterange', value: [], name: 'bankRecordPayTime', sql: 'dateBetween' }
                ]
            },
            allTypeValue: []
        };
    },
    mounted() {
        let beginEndDate = this.mainTable.searchForm.find(e => {
            return e.name === 'bankRecordPayTime';
        });
        beginEndDate.value = [this.getThisMonthStart() + " 00:00:00", this.getTodayDateString() + " 00:00:00"];
        this.$refs.searchCard.handleSearch();
        // this.init();
    },
    methods: {
        formatPayType,
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getMainTableRecords();
        },
        onUserTypeChage(){
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "memberType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'memberType',
                    type: 'eq',
                    value: this.userType
                });
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'bankRecordIsPaid',
                    type: 'eq',
                    value: 1
                });
            }
            getBankRecordList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.allTypeValue = res.data.allTypeValue;
                    this.mainTable.tableData = res.data.records;
                    let totalValue = 0;
                    let totalFee = 0;
                    this.mainTable.tableData.forEach(e => {
                        totalValue += e.bankRecordOrderValue;
                        totalFee += e.bankRecordOrderValueFee;
                    });
                    this.mainTable.tableData.push({
                        bankRecordOrderNo: '本页合计:',
                        bankRecordOrderValue: numberToFixed(totalValue, 2),
                        bankRecordOrderValueFee: totalFee
                    });
                    totalValue = 0;
                    totalFee = 0;
                    this.allTypeValue.forEach(e => {
                        totalValue += e.totalValue;
                    });
                    this.allTypeValue.forEach(e => {
                        totalFee += e.totalFee;
                    });
                    this.mainTable.tableData.push({
                        bankRecordOrderNo: '总合计:',
                        bankRecordOrderValue: numberToFixed(totalValue, 2),
                        bankRecordOrderValueFee: totalFee
                    });

                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
